<template>
    <el-button-group v-if="config.grouped" class="x-button-group"
        :style="`float:${config.align || 'left'}; text-align:${config.align || 'left'};`">

        <template v-for="(buttonConfig, index) in config.buttons" :key="index">
            <el-upload
                v-if="!!buttonConfig.upload && getVisible(buttonConfig.fullCode, buttonConfig.visible, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                :headers="{'Authorization': 'Bearer ' + tokenStore.token}"
                :action="getHref(buttonConfig.upload, data)" :show-file-list="false"
                :on-success="() => uploadSuccessHandler(buttonConfig)" :on-error="() => uploadErrorHandler(buttonConfig)">
                <el-button :class="!buttonConfig.name ? 'no-name' : ''" :disabled="buttonConfig"
                    :type="buttonConfig.type || 'primary'" :link="buttonConfig.link" :icon="buttonConfig.icon"
                    :size="buttonConfig.size || 'default'">{{ getName(buttonConfig.name, data) }}</el-button>
            </el-upload>
            <el-link
                v-else-if="!!buttonConfig.link && getVisible(buttonConfig.fullCode, buttonConfig.visible, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                :href="getHref(buttonConfig.link, data)" target="_blank">
                <el-button :class="!buttonConfig.name ? 'no-name' : ''"
                    :disabled="getReadonly(buttonConfig.fullCode, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                    :type="buttonConfig.type || 'primary'" :icon="buttonConfig.icon"
                    :size="buttonConfig.size || 'default'">{{ getName(buttonConfig.name, data) }}</el-button>
            </el-link>
            <el-button v-else-if="getVisible(buttonConfig.fullCode, buttonConfig.visible, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                :class="!buttonConfig.name ? 'no-name' : ''"
                :disabled="getReadonly(buttonConfig.fullCode, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                :type="buttonConfig.type || 'primary'" :link="buttonConfig.link" :icon="buttonConfig.icon"
                :size="buttonConfig.size || 'default'" @click="$emit('click', buttonConfig)">
                {{ getName(buttonConfig.name, data) }}
            </el-button>
        </template>
    </el-button-group>
    <div v-else-if="config.maxCount" @click.stop class="x-button-group"
        :style="`float:${config.align || 'left'}; text-align:${config.align || 'left'}; `">
        <template v-for="(buttonConfig, index) in getCountButtons(config.buttons, config.maxCount)" :key="index">
            <el-upload
                v-if="!!buttonConfig.upload && !(buttonConfig.upload instanceof Array) && getVisible(buttonConfig.fullCode, buttonConfig.visible, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                :headers="{'Authorization': 'Bearer ' + tokenStore.token}"
                :action="getHref(buttonConfig.upload, data)" :show-file-list="false"
                :on-success="() => uploadSuccessHandler(buttonConfig)" :on-error="() => uploadErrorHandler(buttonConfig)">
                <el-button :class="!buttonConfig.name ? 'no-name' : ''"
                    :disabled="getReadonly(buttonConfig.fullCode, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                    :type="buttonConfig.type || 'primary'" :link="buttonConfig.link" :icon="buttonConfig.icon"
                    :size="buttonConfig.size || 'default'">{{ getName(buttonConfig.name, data) }}</el-button>
            </el-upload>
            <el-link
                v-else-if="!!buttonConfig.link && !(buttonConfig.link instanceof Array) && getVisible(buttonConfig.fullCode, buttonConfig.visible, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                :href="getHref(buttonConfig.link, data)" target="_self">
                <el-button :class="!buttonConfig.name ? 'no-name' : ''"
                    :disabled="getReadonly(buttonConfig.fullCode, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                    :type="buttonConfig.type || 'primary'" :icon="buttonConfig.icon"
                    :size="buttonConfig.size || 'default'">{{ getName(buttonConfig.name, data) }}</el-button>
            </el-link>
            <el-button v-else-if="getVisible(buttonConfig.fullCode, buttonConfig.visible, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                :class="!buttonConfig.name ? 'no-name' : ''"
                :disabled="getReadonly(buttonConfig.fullCode, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                :type="buttonConfig.type || 'primary'" :link="buttonConfig.link" :icon="buttonConfig.icon"
                :size="buttonConfig.size || 'default'" @click="$emit('click', buttonConfig)">
                {{ getName(buttonConfig.name, data) }}
            </el-button>
        </template>
        <el-popover v-if="config.maxCount < config.buttons?.length" placement="bottom" :width="100" trigger="click"
            popper-class="x-button-popper">
            <template #reference>
                <el-button link :size="'small'" :icon="CaretBottom"></el-button>
            </template>
            <template #default>
                <template v-for="(buttonConfig, index) in getCountButtons(config.buttons, config.maxCount, true)"
                    :key="index">
                    <el-upload style="width:100%; margin:0"
                        v-if="!!buttonConfig.upload && !(buttonConfig.upload instanceof Array) && getVisible(buttonConfig.fullCode, buttonConfig.visible, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                        :headers="{'Authorization': 'Bearer ' + tokenStore.token}"
                        :action="getHref(buttonConfig.upload, data)" :show-file-list="false"
                        :on-success="() => uploadSuccessHandler(buttonConfig)"
                        :on-error="() => uploadErrorHandler(buttonConfig)">
                        <el-button :class="!buttonConfig.name ? 'no-name' : ''"
                            :disabled="getReadonly(buttonConfig.fullCode, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                            :type="buttonConfig.type || 'primary'" :link="buttonConfig.link" :icon="buttonConfig.icon"
                            :size="buttonConfig.size || 'default'">{{ getName(buttonConfig.name, data) }}</el-button>
                    </el-upload>
                    <el-link style="width:100%; margin:0"
                        v-else-if="!!buttonConfig.link && !(buttonConfig.link instanceof Array) && getVisible(buttonConfig.fullCode, buttonConfig.visible, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                        :href="getHref(buttonConfig.link, data)" target="_self">
                        <el-button :class="!buttonConfig.name ? 'no-name' : ''"
                            :disabled="getReadonly(buttonConfig.fullCode, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                            :type="buttonConfig.type || 'primary'" :icon="buttonConfig.icon"
                            :size="buttonConfig.size || 'default'">{{ getName(buttonConfig.name, data) }}</el-button>
                    </el-link>
                    <el-button style="width:100%; margin:0"
                        v-else-if="getVisible(buttonConfig.fullCode, buttonConfig.visible, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                        :class="!buttonConfig.name ? 'no-name' : ''"
                        :disabled="getReadonly(buttonConfig.fullCode, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                        :type="buttonConfig.type || 'primary'" :link="buttonConfig.link" :icon="buttonConfig.icon"
                        :size="buttonConfig.size || 'default'" @click="$emit('click', buttonConfig)">
                        {{ getName(buttonConfig.name, data) }}
                    </el-button>
                </template>
            </template>
        </el-popover>
    </div>
    <div v-else @click.stop class="x-button-group"
        :style="`float:${config.align || 'left'}; text-align:${config.align || 'left'}; `">
        <template v-for="(buttonConfig, index) in config.buttons" :key="index">
            <el-upload
                v-if="!!buttonConfig.upload && !(buttonConfig.upload instanceof Array) && getVisible(buttonConfig.fullCode, buttonConfig.visible, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                :headers="{'Authorization': 'Bearer ' + tokenStore.token}"
                :action="getHref(buttonConfig.upload, data)" :show-file-list="false"
                :on-success="() => uploadSuccessHandler(buttonConfig)" :on-error="() => uploadErrorHandler(buttonConfig)">
                <el-button :class="!buttonConfig.name ? 'no-name' : ''"
                    v-if="getVisible(buttonConfig.fullCode, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                    :disabled="getReadonly(buttonConfig.fullCode, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                    :type="buttonConfig.type || 'primary'" :link="buttonConfig.link" :icon="buttonConfig.icon"
                    :size="buttonConfig.size || 'default'">{{ getName(buttonConfig.name, data) }}</el-button>
            </el-upload>
            <el-popover
                v-else-if="!!buttonConfig.upload && (buttonConfig.upload instanceof Array) && getVisible(buttonConfig.fullCode, buttonConfig.visible, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                placement="bottom" width="auto" trigger="click" popper-class="upload-popper">
                <template #reference>
                    <el-button :class="!buttonConfig.name ? 'no-name' : ''"
                        v-if="getVisible(buttonConfig.fullCode, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                        :disabled="getReadonly(buttonConfig.fullCode, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                        :type="buttonConfig.type || 'primary'" :link="buttonConfig.link" :icon="buttonConfig.icon"
                        :size="buttonConfig.size || 'default'" style="margin-right:5px !important;">{{
                            getName(buttonConfig.name, data) }}<el-icon style="margin-left:6px;">
                            <CaretBottom />
                        </el-icon></el-button>
                </template>
                <template #default>
                    <el-upload v-for="(bconfig, index) in buttonConfig.upload" :key="index"
                        :headers="{'Authorization': 'Bearer ' + tokenStore.token}"    
                        :action="getHref(bconfig.upload, data)" :show-file-list="false"
                        :on-success="() => uploadSuccessHandler(bconfig)" :on-error="() => uploadErrorHandler(bconfig)">
                        <div>{{ getName(bconfig.name, data) }}</div>
                    </el-upload>
                </template>
            </el-popover>
            <el-link
                v-else-if="!!buttonConfig.link && !(buttonConfig.link instanceof Array) && getVisible(buttonConfig.fullCode, buttonConfig.visible, buttonConfig.readonly, data)"
                :href="getHref(buttonConfig.link, data)" target="_self">
                <el-button :class="!buttonConfig.name ? 'no-name' : ''"
                    v-if="getVisible(buttonConfig.fullCode, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                    :disabled="getReadonly(buttonConfig.fullCode, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                    :type="buttonConfig.type || 'primary'" :icon="buttonConfig.icon"
                    :size="buttonConfig.size || 'default'">{{ getName(buttonConfig.name, data) }}</el-button>
            </el-link>
            <el-popover
                v-else-if="!!buttonConfig.link && (buttonConfig.link instanceof Array) && getVisible(buttonConfig.fullCode, buttonConfig.visible, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                placement="bottom" width="auto" trigger="click" popper-class="upload-popper">
                <template #reference>
                    <el-button :class="!buttonConfig.name ? 'no-name' : ''"
                        v-if="getVisible(buttonConfig.fullCode, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                        :disabled="getReadonly(buttonConfig.fullCode, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                        :type="buttonConfig.type || 'primary'" :icon="buttonConfig.icon"
                        :size="buttonConfig.size || 'default'" style="margin-right:5px !important;">{{
                            getName(buttonConfig.name, data) }}<el-icon style="margin-left:6px;">
                            <CaretBottom />
                        </el-icon></el-button>
                </template>
                <template #default>
                    <el-link v-for="(bconfig, index) in buttonConfig.link" :key="index"
                        :href="getHref(bconfig.link, data)" target="_self">
                        <!-- <div>{{ getName(bconfig.name, data) }}</div> -->
                        <el-button :class="!bconfig.name ? 'no-name' : ''"
                            v-if="getVisible(bconfig.fullCode, bconfig.readonly, data, bconfig.name, bconfig.module, bconfig)"
                            :disabled="getReadonly(bconfig.fullCode, bconfig.readonly, data, bconfig.name, bconfig.module, bconfig)"
                            :type="bconfig.type || 'primary'" :icon="bconfig.icon" :size="bconfig.size || 'default'">{{
                                getName(bconfig.name, data) }}</el-button>
                    </el-link>
                </template>
            </el-popover>
            <template v-else>
                <el-button
                    v-if="!buttonConfig.children && getVisible(buttonConfig.fullCode, buttonConfig.visible, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                    :class="!buttonConfig.name ? 'no-name' : ''"
                    :disabled="getReadonly(buttonConfig.fullCode, buttonConfig.readonly, data, buttonConfig.name, buttonConfig.module, buttonConfig)"
                    :type="buttonConfig.type || 'primary'" :link="buttonConfig.link" :icon="buttonConfig.icon"
                    :size="buttonConfig.size || 'default'" @click="$emit('click', buttonConfig)">
                    {{ getName(buttonConfig.name, data) }}
                </el-button>
                <el-popover v-else-if="buttonConfig.children" placement="bottom" width="auto" trigger="click">
                    <template #reference>
                        <el-button :class="!buttonConfig.name ? 'no-name' : ''" :type="buttonConfig.type || 'primary'"
                            :icon="buttonConfig.icon" :size="buttonConfig.size || 'default'"
                            style="margin-right:5px !important;">
                            {{ getName(buttonConfig.name, data) }}
                            <el-icon style="margin-left:6px;">
                                <CaretBottom />
                            </el-icon>
                        </el-button>
                    </template>
                    <template #default>
                        <el-button v-for="(bconfig, index) in buttonConfig.children" :key="index"
                            :class="!bconfig.name ? 'no-name' : ''"
                            :disabled="getReadonly(bconfig.fullCode, bconfig.readonly, data, bconfig.name, bconfig.module, bconfig)"
                            :type="bconfig.type || 'primary'" :link="bconfig.link" :icon="bconfig.icon"
                            :size="bconfig.size || 'default'" @click="$emit('click', bconfig)">
                            {{ getName(bconfig.name, data) }}
                        </el-button>
                    </template>
                </el-popover>
            </template>
        </template>
    </div>
</template>
<script setup>
import { getCurrentInstance, ref, watch } from 'vue';
import { CaretBottom } from '@element-plus/icons-vue';
import { addURLParams, formatDataUrl } from '../../remoteservice/RemoteCenter';
import { getBoolean, getString, getPermissions } from '../../business/Computer'
import { ElMessageBox } from 'element-plus';
import DataPermissionManager from '../../datapermission/DataPermissionManager'
import { useTokenStore } from '../../store/TokenStore';
import PermissionManager from '../../permission/PermissionManage';

const hideReadonly = true;

const tokenStore = useTokenStore();

const inst = getCurrentInstance();

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    data: { default: null },
    field: { default: null },
})

defineEmits({
    click: null,
})

const getCountButtons = (buttons, count, extend) => {
    if (!buttons) return [];
    if (buttons.length <= count) {
        if (!extend) return buttons;
        else return [];
    } else {
        if (!extend) {
            return buttons.slice(0, count - 1);
        } else {
            return buttons.slice(count - 1);
        }
    }

}

const getHref = (link, data) => {
    const urlInfo = formatDataUrl(link, data);
    const url = addURLParams(urlInfo.url, Object.assign(urlInfo.params, urlInfo.body));
    return url;
}

const getVisible = (code, visible, readonly, data, name, module, config) => {
    if (hideReadonly) return !getReadonly(code, readonly, data, name, module, config);
    else return getBoolean(visible, data, true)
}
const getReadonly = (code, readonly, data, name, module, config) => {
    if (!code) return false;
    // /\/([^\/]*?)$/.test(code)
    const cc = code;
    // console.log(props.dataView.getModuleCode())
    // console.log('%cbutton code ' + code + ' ' + name + module, 'color:blue');
    if (cc == 'VIEW') return false;
    let r = getBoolean(readonly, data, false);
    // console.log(code)
    r = r || !(!data || cc == 'VIEW' || (cc == 'UNLOCK' && data.lockStatus == '1' && data.lockBy == tokenStore.username) || tokenStore.isBizManager || (cc != 'UNLOCK' && data.lockStatus != '1'));
    // process function permission
    // r = r || !getPermissions(code, inst.proxy.$router.currentRoute.value.path,module,config.config?.url)
    // console.log(code)
    const pmodule = config.scope || module;
    const pcode = config.opt || code;
    const batch = config.batch;
    const pstr = `${pmodule}/${pcode}${batch ? '+' : ''}`;
    r = r || !PermissionManager.checkPermission(pstr);

    // process data permission
    if (!(/\/VIEW$/.test(code)))
        r = r || !DataPermissionManager.checkDataPermission(pmodule, data);
    // r = false
    return r;
}
const getName = (name, data) => {
    return getString(name, data, '');
}

const uploadSuccessHandler = (buttonConfig) => {
    // this.data._t = Math.floor(Date.now() / 1000);
    // ElMessageBox.alert(CONSTANT.HINT_UPLOAD_SUCCESS, CONSTANT.TITLE_UPLOAD_DATA, { type:'info' })
    inst.emit('click', buttonConfig);
}
const uploadErrorHandler = (params) => {
    // ElMessageBox.alert(CONSTANT.HINT_UPLOAD_ERROR, CONSTANT.TITLE_UPLOAD_DATA, { type:'error' })
}
</script>
<style>
.upload-popper .el-upload--text {
    width: 100%;
    padding: 5px;
    background: #387aca;
    color: #fff;
    margin: 2px 0;
    box-sizing: border-box;
    border-radius: 4px;
}

.upload-popper .el-upload--text:hover {
    background: #20518F;
}

.upload-popper .el-link {
    display: block;
}

.upload-popper .el-link:hover::after {
    display: none;
}

.upload-popper .el-link__inner {
    /*padding: 4px 6px;*/
    display: block;
}

.upload-popper .el-button {
    width: 100%;
    padding: 5px;
    background: #387aca;
    color: #fff;
    margin: 2px 0;
    box-sizing: border-box;
    border-radius: 4px;
}

.upload-popper .el-button:hover {
    background: #20518F;
}

.x-button-popper {
    min-width: 100px !important;
}

.x-button-popper>.el-button {
    padding: 6px 0;
}

.x-button-popper>.el-button--primary:hover {
    background: var(--el-color-primary) !important;
    color: #FFF;
}

.x-button-popper>.el-button--danger:hover {
    background: var(--el-color-danger) !important;
    color: #FFF;
}

.x-button-popper>.el-button--success:hover {
    background: var(--el-color-success) !important;
    color: #FFF;
}

.x-button-popper>.el-button--warning:hover {
    background: var(--el-color-warning) !important;
    color: #FFF;
}

.x-button-popper>.el-button--info:hover {
    background: var(--el-color-info) !important;
    color: #FFF;
}

.x-button-popper>.el-button.is-disabled:hover {
    background: transparent !important;
}</style>